import { initialState } from '..';
import type { BetSlipState } from '../types';

const selectionsCleared = (state: BetSlipState): BetSlipState => ({
  ...state,
  acceptedOdds: initialState.acceptedOdds,
  errorCode: undefined,
  opportunities: initialState.opportunities,
  selections: initialState.selections,
  selectedPromotionPicker: initialState.selectedPromotionPicker
});

export default selectionsCleared;
